import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: currentColor;
  opacity: 0.3;
  border: none;
  margin: 0;
  flex-shrink: 0;
`;
